import { all, fork } from "redux-saga/effects";
import { componentSaga } from "./components/saga";
import { pageSaga } from "./pages/saga";
import { hooksSaga } from "./hooks/saga";

export function* rootSaga() {
  yield all([fork(componentSaga), fork(pageSaga), fork(hooksSaga)]);
}
